(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-conforpas"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.cp-benefits').forEach(initBenefitsSection);

  function initBenefitsSection(section) {
    if (section.dataset.cpBfInit === 'true') return;
    section.dataset.cpBfInit = 'true';

    if (section.dataset.animate === 'true' && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      section.querySelectorAll('.cp-bf-fade').forEach(function (el) {
        observer.observe(el);
      });
    } else {
      section.querySelectorAll('.cp-bf-fade').forEach(function (el) {
        el.classList.add('is-in-view');
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers-conforpas"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.cp-bs').forEach(initBestSellersSection);

  function initBestSellersSection(section) {
  if (section.dataset.cpBsInit === 'true') return;
  section.dataset.cpBsInit = 'true';

  /* ---------- Fade-in on scroll ---------- */
  if (section.dataset.animate === 'true' && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    section.querySelectorAll('.cp-bs-fade').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    section.querySelectorAll('.cp-bs-fade').forEach(function (el) {
      el.classList.add('is-in-view');
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WISHLIST_KEY = 'cp_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) { /* storage unavailable, fail silently */ }
  }

  function refreshWishlistButtons() {
    var list = getWishlist();
    section.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.setAttribute('aria-pressed', list.indexOf(id) > -1 ? 'true' : 'false');
    });
  }

  section.addEventListener('click', function (e) {
    var wishBtn = e.target.closest('[data-wishlist-toggle]');
    if (!wishBtn) return;
    var id = wishBtn.getAttribute('data-product-id');
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(id);
    }
    setWishlist(list);
    refreshWishlistButtons();
  });

  refreshWishlistButtons();

  /* ---------- Mobile tap-to-reveal hover image ---------- */
  if (!window.matchMedia('(hover: hover)').matches) {
    section.querySelectorAll('.cp-bs-card__media-link').forEach(function (link) {
      link.addEventListener('touchstart', function () {
        var card = link.closest('.cp-bs-card');
        if (card) card.classList.add('cp-bs-card--tapped');
      }, { passive: true });
    });
  }

  /* ---------- Cart toast ---------- */
  var toast = section.querySelector('[data-cart-toast]');
  var toastMessage = section.querySelector('[data-cart-toast-message]');
  var toastTimer;

  function showToast(message) {
    if (!toast) return;
    if (toastMessage) toastMessage.textContent = message;
    toast.hidden = false;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 250);
    }, 2600);
  }

  /* ---------- Quick Add + Size selection ---------- */
  function addVariantToCart(variantId, button) {
    button.classList.add('is-loading');
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        button.classList.remove('is-loading');
        showToast('Added to cart');
        /* Notify the theme's cart drawer/count if present (Dawn-compatible) */
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            cartDrawer.renderContents(cart);
          });
        }
      })
      .catch(function () {
        button.classList.remove('is-loading');
        showToast("Couldn't add to cart — please try again");
      });
  }

  section.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add-trigger]');
    if (trigger) {
      var card = trigger.closest('.cp-bs-card');
      var picker = card ? card.querySelector('[data-size-picker]') : null;

      if (picker) {
        var isOpen = !picker.hidden;
        section.querySelectorAll('[data-size-picker]').forEach(function (p) { p.hidden = true; });
        picker.hidden = isOpen;
        return;
      }

      /* Single-variant product: get its only variant id from the trigger's data */
      var singleVariantId = trigger.getAttribute('data-variant-id');
      if (!singleVariantId && card) {
        var firstOption = card.querySelector('[data-variant-id]');
        singleVariantId = firstOption ? firstOption.getAttribute('data-variant-id') : null;
      }
      if (singleVariantId) {
        addVariantToCart(singleVariantId, trigger);
      }
      return;
    }

    var sizeOption = e.target.closest('.cp-bs-size-option');
    if (sizeOption && !sizeOption.disabled) {
      var quickAddBtn = sizeOption.closest('.cp-bs-card').querySelector('[data-quick-add-trigger]');
      addVariantToCart(sizeOption.getAttribute('data-variant-id'), quickAddBtn);
      sizeOption.closest('[data-size-picker]').hidden = true;
    }
  });
  } /* end initBestSellersSection */
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-conforpas"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-hero-video-wrap]').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      video.pause();
      video.removeAttribute('autoplay');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.cp-nl').forEach(initNewsletterSection);

  function initNewsletterSection(section) {
    if (section.dataset.cpNlInit === 'true') return;
    section.dataset.cpNlInit = 'true';

    if (section.dataset.animate === 'true' && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      section.querySelectorAll('.cp-nl-fade').forEach(function (el) {
        observer.observe(el);
      });
    } else {
      section.querySelectorAll('.cp-nl-fade').forEach(function (el) {
        el.classList.add('is-in-view');
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
